const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const AppDispatcher = FuzzyReaction.Dispatcher;
const assign = require('object-assign');
const ModelStore = FuzzyReaction.Stores.ModelStore;

/**
 * Data stores
 * @type {Array}
 * @private
 */
// Store for table data
let _resourceListData = [];
let _resourceData = {};

const sortByProperty = function (property) {

    return function (x, y) {

        return ((x[property] === y[property]) ? 0 : ((x[property] < y[property]) ? 1 : -1));

    };

};

/**
 * User store logic
 *
 * @type {*|exports}
 */
const CodeStore = assign({}, ModelStore, {
    getResourceListData: function () {
        return _resourceListData.sort(sortByProperty('id'));
    },

    getResource: function () {
        return _resourceData;
    },

    getResourceById: function (id) {
        // http://stackoverflow.com/questions/12553274/getting-index-of-an-arrays-element-based-on-its-properties
        const index = _resourceListData.map(function (item) {
            return item.id;
        }).indexOf(Number(id));

        return _resourceListData[index];
    }
});

/**
 * Event Listeners
 */
CodeStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.type) {
        case 'GENERATION-CODES_RECEIVED':
            _resourceData = action.data;

            CodeStore.emitChange();
            break;
        case 'GENERATION-CODES_CREATED':
            _resourceData = action.data;

            CodeStore.emitChange();
            break;
        case 'GENERATION-CODES_LISTED':
            _resourceListData = action.data;

            CodeStore.emitChange();
            break;
        case 'ME_LISTED':
            _resourceData = action.data;

            CodeStore.emitChange();
            break;
    }
});

module.exports = CodeStore;
